// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"631fd89f","239":"5491b2ce","732":"a38800b4","810":"f4abca7f","977":"8dcf2e85"}[chunkId] + ".chunk.js";
};